<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ProcessStepsDataProvider',
  props: {
    processId: {
      type: String,
      default: '0'
    }
  },
  data: () => ({
    showCreate: false
  }),
  computed: mapGetters('processes', {
    processName: 'processName',
    processSteps: 'processSteps'
  }),
  methods: {
    createProcessStep({ processId, name, description }) {
      this.$store
        .dispatch('processes/createProcessStep', {
          processId: processId,
          name: name,
          description: description
        })
        .then(value => {
          this.setShowCreate(false);
        });
    },
    deleteProcessStep(processStepId) {
      this.$store.dispatch('processes/deleteProcessStep', {
        processId: this.processId,
        id: processStepId
      });
    },
    editProcessStep({ id, name, description }) {
      this.$store.dispatch('processes/editProcessStep', {
        processId: this.processId,
        id: id,
        name: name,
        description: description
      });
    },
    sortProcessStep({ id, sortIndex }) {
      this.$store.dispatch('processes/sortProcessStep', {
        processId: this.processId,
        id: id,
        sortIndex: sortIndex
      });
    },
    setShowCreate(value) {
      this.showCreate = value;
    },
    publish({ id }) {
      this.$store.dispatch('processes/publishProcessStep', {
        processId: this.processId,
        id: id
      });
    },
    unpublish({ id }) {
      this.$store.dispatch('processes/unpublishProcessStep', {
        processId: this.processId,
        id: id
      });
    }
  },
  render() {
    if (!this.$scopedSlots.default) {
      return;
    }

    const slotScope = {
      processName: this.processName(this.processId),
      processSteps: this.processSteps(this.processId),
      createProcessStep: this.createProcessStep,
      deleteProcessStep: this.deleteProcessStep,
      editProcessStep: this.editProcessStep,
      setShowCreate: this.setShowCreate,
      showCreate: this.showCreate,
      sortProcessStep: this.sortProcessStep,
      publish: this.publish,
      unpublish: this.unpublish
    };

    return this.$scopedSlots.default(slotScope);
  }
};
</script>
